import { render, staticRenderFns } from "./SerialManagement.vue?vue&type=template&id=a62a0436&"
import script from "./SerialManagement.js?vue&type=script&lang=js&"
export * from "./SerialManagement.js?vue&type=script&lang=js&"
import style0 from "./SerialManagement.vue?vue&type=style&index=0&id=a62a0436&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports